import { useCallback, useEffect, useState } from 'react';
import Cookies from 'universal-cookie';

const zipcodeEventName = 'zipcodeUpdate';
const cookies = new Cookies();
const isHonda = process.env.REACT_APP_THEME === 'honda';

const useZipcode = () => {
  const initialZipcode = isHonda
    ? cookies.get('zipcode') || ''
    : localStorage.getItem('userZipCode') || '';

  const [zipcode, setZipcode] = useState(initialZipcode);

  const triggerZipcodeUpdate = useCallback((value: string) => {
    if (isHonda) {
      const customEvent = new CustomEvent(zipcodeEventName, {
        detail: {
          zipcode: value,
        },
      });
      window.dispatchEvent(customEvent);
      setZipcode(value);

      //The publish method below will affect the FE testing
      //It was added to fit with the current method used in Honda Autos
      //If you need to try the FE Charging Locator app, comment the line
      window.EventManager.publish('global-zip-update', value);
      const eventObject = new CustomEvent('global-zip-update', {
        detail: value,
      });
      document.dispatchEvent(eventObject);
    } else {
      localStorage.setItem('userZipCode', value);
      const customEvent = new CustomEvent(zipcodeEventName, {
        detail: {
          zipcode: value,
        },
      });
      window.dispatchEvent(customEvent);
      setZipcode(value);
    }
  }, []);

  useEffect(() => {
    const handleZipcodeUpdate = (event: any) => {
      setZipcode(event.detail.zipcode);
    };

    const handleZipcodeUpdateAutos = (event: any) => {
      setZipcode(event.detail);
    };

    window.addEventListener(zipcodeEventName, handleZipcodeUpdate);
    window.addEventListener('global-zip-update', handleZipcodeUpdateAutos);

    return () => {
      window.removeEventListener(zipcodeEventName, handleZipcodeUpdate);
      window.removeEventListener('global-zip-update', handleZipcodeUpdateAutos);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { zipcode, triggerZipcodeUpdate };
};

export default useZipcode;
